import React, { useState, useCallback, useEffect } from 'react';
import { kpiApi } from '../../services/api';
import { useDbNavigate } from '../../context/DatabaseContext';
import { ClipboardList, History, Cog } from 'lucide-react';
import DashboardLayout from '../../components/common/DashboardLayout';
import DashboardTile from '../../components/common/DashboardTile';

const SooDashboardPage = () => {
  const navigate = useDbNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [kpis, setKpis] = useState(null);

  const loadKpis = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await kpiApi.getSoo();
      setKpis(response.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load KPIs');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const handler = () => loadKpis();
    window.addEventListener('pmd-database-changed', handler);
    return () => window.removeEventListener('pmd-database-changed', handler);
  }, [loadKpis]);

  const StatCard = ({ value, label, icon: Icon, colorClass = 'stui-c-primary' }) => (
    <div className="stui-dashboard-visual-stat-card">
      <div className={`stui-dashboard-visual-stat-icon ${colorClass}`}>
        <Icon size={24} />
      </div>
      <div className="stui-dashboard-visual-stat-value">{(value || 0).toLocaleString()}</div>
      <div className="stui-dashboard-visual-stat-label">{label}</div>
    </div>
  );

  return (
    <DashboardLayout
      id="soo"
      title="Sequences of Operation"
      icon={ClipboardList}
      onRefresh={loadKpis}
      loading={loading}
      error={error}
    >
      <DashboardTile
        title="Sequences of Operation"
        icon={ClipboardList}
        onClick={() => navigate('/soo-index')}
        colSpan={3}
      >
        <div className="stui-dashboard-visual-stat-row">
          <StatCard value={kpis?.sooCount} label="Total SOOs" icon={ClipboardList} colorClass="stui-c-emerald" />
          <StatCard value={kpis?.sooVersions} label="Versions" icon={History} colorClass="stui-c-teal" />
          <StatCard value={kpis?.sooEquipment} label="Equipment" icon={Cog} colorClass="stui-c-cyan" />
        </div>
      </DashboardTile>
    </DashboardLayout>
  );
};

export default SooDashboardPage;
